// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24o8t","select":"styles_select__2NtIn"};